export enum WorkOrderStatus {
  New = "New",
  Assigned = "Assigned",
  Unassigned = "Unassigned",
  Reassigned = "Reassigned",
  Hold = "Hold",
  InProgress = "InProgress",
  Complete = "Complete",
  Cancelled = "Cancelled",
  UnableToBeAutoAssigned = "UnableToBeAutoAssigned",
  HoldPreviousDay = "HoldPreviousDay",
}
